import {
    isAlphaProfile,
    isBetaProfile,
    isDevProfile,
    isLocalProfile,
    isStoryBookProfile,
    isTestProfile,
} from '@web/core/config'

import {FDS_BLOCK_REASON} from '../constants'
import {getCurrentPath, getHref, stringifyUrl} from '../utils'

import domains from './domains'

type FDSBlockReasonType = Constant<typeof FDS_BLOCK_REASON>

export const PAY = domains.PAY

export const NAVER_TALK = domains.NAVER_TALK

export const CARD = domains.CARD

export const CARD_PAY = domains.CARD_PAY

export const NID = domains.NID

export const NPAY_BIZ = domains.NPAY_BIZ

export const PC_PAY = domains.PC_PAY

export const CUSTOMS = `${domains.CUSTOMS}/csp/persIndex.do`

export const PAY_M = domains.PAY_M

export const SHOPPING_LIVE = (() => {
    const domain = domains.SHOPPING_LIVE
    if (isLocalProfile) {
        return `${domain}/live-commerce/modules/npay/latest/dev/`
    } else if (isDevProfile || isAlphaProfile || isStoryBookProfile) {
        return `${domain}/live-commerce/modules/npay/latest/dev/`
    } else if (isBetaProfile) {
        return `${domain}/live-commerce/modules/npay/latest/stage/`
    } else if (isTestProfile) {
        return `${domain}/live-commerce/modules/npay/latest/dev/`
    } else {
        return `${domain}/live-commerce/modules/npay/latest/real/`
    }
})()

export const SHOPPING_LIVE_LAUNCHER = (() => {
    const domain = domains.SHOPPING_LIVE
    if (isLocalProfile) {
        return `${domain}/live-commerce/modules/launcher/latest/index.js`
    } else if (isDevProfile || isAlphaProfile || isStoryBookProfile) {
        return `${domain}/live-commerce/modules/launcher/latest/index.js`
    } else if (isBetaProfile) {
        return `${domain}/live-commerce/modules/launcher/0.20.1/index.js`
    } else if (isTestProfile) {
        return `${domain}/live-commerce/modules/launcher/latest/index.js`
    } else {
        return `${domain}/live-commerce/modules/launcher/0.20.1/index.js`
    }
})()

export const AITEMS_MORE = `${domains.NAVER_BLOG_M}/naver_search/221086300708`

export const FOR_YOU = (() => {
    const domain = domains.FOR_YOU
    if (isLocalProfile) {
        return `${domain}/myai/foryou`
    } else {
        return `${domain}/ns/home/for-you`
    }
})()

export const CPM_POINT_GAMBLE = `${domains.CAMPAIGN}/npay/gorandomp`

export const SHOPPING = domains.SHOPPING

export const M_SHOPPING = domains.M_SHOPPING

export const GIFT = domains.GIFT

export const PC_HELP = domains.PC_HELP

export const M_HELP = domains.M_HELP

export const CART = `${domains.CART}/cart`

export const PC_ORDER = domains.PC_ORDER

export const ORDER_DEV = domains.ORDER_DEV

export const TALK_TALK = domains.TALK_TALK

export const NAVER_TALK_LIST = domains.NAVER_TALK_LIST

export const DANAL_PG = domains.DANAL_PG

export const MOBILIANS_PG = domains.MOBILIANS_PG

export const PAY_PC = domains.PAY

export const AB_TEST_LOG = `${domains.AB_TEST_LOG}/a`

export const L_PAY = domains.L_PAY

export const ORDERS = domains.ORDERS

export const RENTAL = `${domains.ORDERS}/order/rental`

export const NAVER = domains.NAVER

export const NAVER_PC = domains.NAVER_PC

export const HELP = domains.HELP

export const FOREIGN_SETTING = domains.FOREIGN_SETTING

/** 상품 URL 기본값 */
export const DEFAULT_PRODUCT_URL = `${domains.PC_ORDER}/home`

export const DEFAULT_PRODUCT_URL_M = domains.PAY

export const FLEA_MARKET = domains.FLEA_MARKET

/** 제휴포인트 전환 페이지 */

export const AFFILIATE_POINT_CONVERTING_URL = `${domains.PAY}/pay-point-convert-in/pointconvert`

/** 오픈뱅킹 참여 금웅사 약관 페이지 */
export const OPEN_BANKING_TERMS_URL = `${domains.PAY}/mydata/agreement/simplepay/openbank/bank`

/** 금융결제원(Korea Fair Trad Commission)  개인정보 제공 동의 페이지 */
export const KFTC_PERSONAL_INFO_CONCESSION_URL = `${domains.PAY}/mydata/agreement/simplepay/kftc`

/** 결제내역 PC용 페이지 */
export const TIMELINE_URL = `${domains.PAY}/pc/history`

/** 결제내역 MOBILE용 페이지 */
export const TIMELINE_MOBILE_URL = `${domains.PAY}/history`

/** 구매적립 혜택정책 PC용 안내 페이지 */
export const BENEFIT_POLICY_INFO_URL = `${domains.PC_HELP}/faq/content.help?faqId=11880`

/** 구매적립 혜택정책 MOBILE용 안내 페이지 */
export const BENEFIT_POLICY_INFO_MOBILE_URL = `${domains.M_HELP}/faq/list.help?rootCategoryId=10518&faqId=11880`

/** 페이혜택카드 정책 PC용 안내 페이지 */
export const PAY_BENEFIT_CARD_INFO_URL = `${domains.PC_HELP}/faq/search.help?categoryId=0&searchKeyword=페이혜택카드`

/** 페이혜택카드 정책 MOBILE용 안내 페이지 */
export const PAY_BENEFIT_CARD_INFO_MOBILE_URL = `${domains.M_HELP}/faq/search.help?keyword=페이혜택카드`

/** 패밀리 멤버십 설정 페이지 */
export const FAMILY_MEMBERSHIP_SETTING_URL = `${domains.PAY}/member/settings/family-payment/manage`

/** 쇼핑 홈 */
export const SHOPPING_HOME = `${domains.SHOPPING}/ns/home`

/** 마이페이지 홈 */
export const PAY_HOME = `${domains.PC_PAY}/mypage/home`

export const PAY_HOME_M = `${domains.PAY_M}/mobile/home`

/** 네이버쇼핑 장바구니 URL */
export const SHOPPING_CART = `${domains.SHOPPING}/cart`

export const SHOPPING_CART_M = `${domains.M_SHOPPING}/cart`

/** 장보기 > 장바구니 URL */
export const SHOPPING_BRANCH_CART = `${domains.SHOPPING}/cart/mart`

/** 간편결제 - 카드 등록 */
export const REGISTER_EASY_CARD = `${domains.CARD}/build/index.html#/card-registration`

/** 간편결제 - 카드 등록 필수 파라미터 */
export const REGISTER_EASY_CARD_WITH_PARAMS = stringifyUrl({
    url: REGISTER_EASY_CARD,
    query: {
        successUrl: window.location.href,
        failUrl: window.location.href,
    },
})

/** 후불결제 */
export const PAY_LATER_HOME = `${domains.PAY}/paylater`

// 후불결제 가입
export const PAY_LATER_SIGNUP = `${domains.PAY}/paylater/signup`

// 후불결제 연체안내
export const PAY_LATER_OVERDUE_PENALTY = `${domains.PAY}/paylater/overdue/penalty`

/** 디지털 컨텐츠 단건 일반결제 */
export const DICON_GENERAL_PAYMENT = `${domains.DICON}/normalPay/payment`

/**
 * 비밀번호/생체 인증 페이지
 * @ref https://yobi.navercorp.com/order-sheet/posts/44#1603095293250
 * */
export const PASS_BIO_AUTH = `${domains.PAY}/authentication/pw/check`

/** ARS 인증(네이버페이) */
export const ARS = `${domains.PAY}/authentication/select`

/** 멤버십 가입 안내 페이지 */
export const JOIN_MEMBERSHIP_GUIDE = `${domains.NID}/membership/join?utm_source=Pay_orderpopup_MO&utm_medium=display&utm_campaign=membership_shoppingpay&utm_content=join_theday`

/** 페이 이용정지 계정 안내 페이지 */
export const MEMBERSHIP_STOP_NOTICE = `${domains.PAY}/stop`

/** 페이 이용정지 계정 안내 페이지 */
export const MEMBERSHIP_STOP_NOTICE_PC = stringifyUrl({
    url: `${domains.PAY}/stop`,
    query: {
        from: 'pc-order',
    },
})

/** 바로결제 설정 페이지 */
export const RIGHT_AWAY_PAY = `${domains.PAY}/member/settings/right-away-pay`

/** 예약/예매/주문 확인 페이지 */
export const MY_BOOKINGS = `${domains.BOOKING}/my/bookings`

/** 테이블/포장/배달 확인 페이지  */
export const MY_ORDERS = `${domains.BOOKING}/my/orders`

export const MOBILE_ANNUAL_MEMBERSHIP = `${domains.NID}/membership/my?m=viewAnnualMembership`

export const REGISTER_EASY_BANK_PC = `${domains.PAY}/mydata/registration/remit/agreement`

/** 현대 네이버페이 머니카드(선불카드) 혜택받기 페이지 */
export const NAVER_PAY_MONEY_CARD_BENEFIT_URL =
    'https://m-campaign.naver.com/collect/v2/?code=2025041410_710001_015_clk_400302_20250414002&target=https%3A%2F%2Fcard.pay.naver.com%2Fprepaid%2Fintro'

/** 개인통관고유부호 해외직구 여기로 */
export const OVERSEA_DIRECT_PURCHASE = 'https://www.customs.go.kr/kcs/ad/cntnts/cntntsView.do?cntntsId=10220&mi=10220'

/** 내 개인통관고유부호 확인하기 */
export const PERSONAL_CUSTOMS_CLEARANCE_CHECK = 'https://unipass.customs.go.kr/csp/persIndex.do'

/** 네이버쇼핑 정기구독 URL */
export const SHOPPING_MY_SUBSCRIPTION = `${domains.SHOPPING}/my/subscriptions`

export const SHOPPING_MY_SUBSCRIPTION_M = `${domains.M_SHOPPING}/my/subscriptions`

/** 네이버 플러스 멤버십 패밀리 멤버 관리 페이지 */
export const NAVER_PLUS_MEMBERSHIP_FAMILY = `${domains.NID}/membership/family`

/** 페이설정 > 회원정보 > 개인정보 처리 동의 목록 */
export const MEMBER_CONSENT_HISTORY = `${domains.PAY}/member/consent-history`

/** 페이설정 > 회원정보 > 패밀리결제 동의 안함 (맴버) */
export const FAMILY_PAY_AGREE_MEMBER_EMPTY = `${domains.PAY}/member/no-history/familyPay-member`

/** 페이설정 > 회원정보 > 패밀리결제 동의 안함 (대표) */
export const FAMILY_PAY_AGREE_ORGANIZER_EMPTY = `${domains.PAY}/member/no-history/familyPay-organizer`

/** 현대 프로모션 카드 혜택 받기 페이지 */
export const HYUNDAI_CARD_PROMOTION_BENEFIT_URL = 'https://mkt.naver.com/naverhyundaicard2/?eventCode=NAV09'

/** 페이머니 페이지 */
export const PAYMONEY = `${domains.PAY}/paymoney`

/** 페이머니 내역 페이지 */
export const PAYMENT_HISTORY = `${domains.PAY}/paymoney/history`

/** 환불정산액 상세 페이지 */
export const REFUND_HISTORY = `${domains.PAY}/member/refund`

/** 결제사용처 목록 페이지 */
export const MERCHANDISER_LIST = `${domains.PAY}/member/terms-policy/merchandiser_list`

/** 패밀리결제 설정 페이지 */
export const FAMILY_PAY_PAYMENT_MANAGE = `${domains.PAY}/member/settings/family-payment/manage`

/** 롯데 프로모션 카드 혜택 받기 페이지 */
export const LOTTE_CARD_PROMOTION_BENEFIT_URL = stringifyUrl({
    url: 'https://internal.pay.naver.com/access/payment/card/r/go',
    query: {redirectUrl: 'https://mkt.naver.com/event/npay-loca'},
})

/** 삼성 TapTap 카드 신청 페이지 */
export const SAMSUNG_TAPTAP_CARD_REGISTER_URL = stringifyUrl({
    url: 'https://internal.pay.naver.com/access/payment/card/r/go',
    query: {redirectUrl: 'https://mkt.naver.com/event/taptapcard'},
})

export const SAMSUNG_WEBTOON_ID_CARD = stringifyUrl({
    url: 'https://internal.pay.naver.com/access/payment/samsung0725/r/go',
    query: {redirectUrl: 'https://mkt.naver.com/event/SS_wt'},
})

/** 신한카드 라인프렌즈 혜택받기 페이지 */
export const SHINHAN_LINE_FRIENDS_BENEFIT_URL = stringifyUrl({
    url: 'https://internal.pay.naver.com/access/payment/card/r/go',
    query: {redirectUrl: 'https://mkt.naver.com/event/npay-shinhanassociated'},
})

/** 국민행복 삼성카드 혜택 페이지 */
export const KOOKMIN_HAPPINESS_SAMSUNG_URL = stringifyUrl({
    url: 'https://internal.pay.naver.com/access/payment/card/r/go',
    query: {redirectUrl: 'https://mkt.naver.com/event/SS_benefit'},
})

export const IBK_NARA_SARANG_URL = 'https://narasarang.ibk.co.kr'

export const KOOKMIN_HAPPINESS_SHINHAN_URL = 'https://card-search.naver.com/item?cardAdId=10035'

/** 구매확정 고객센터  */
export const PURCHASE_CONFIRMATION_HELP = stringifyUrl({
    url: `${domains.PC_HELP}/faq/content.help`,
    query: {
        faqId: '14393',
    },
})

/** 배송조회 고객센터 */
export const DELIVERY_TRACKING_HELP = stringifyUrl({
    url: `${domains.PC_HELP}/mail/form.help`,
    query: {
        alias: 'm_delivery',
    },
})

/** 배송조회 운송장번호 검색 */
export const DELIVERY_TRACKING_SEARCH = stringifyUrl({
    url: 'https://search.naver.com/search.naver',
    query: {
        sm: 'tab_hty.top',
        where: 'nexearch',
        ssc: 'tab.nx.all',
        query: '택배조회',
        oquery: '운송장조회',
        tqi: 'j4uFglqpsECss6GQyxsssssstpV-345240',
        ackey: 'q4h9b428',
    },
})

/** 네이버 전체 서비스 페이지 URL */
export const ALL_NAVER_SERVICES = `${domains.NAVER}/services.html`

/** 네이버페이 혜택 페이지 (국내) */
export const NAVERPAY_BENEFIT_DOMESTIC = `${domains.CAMPAIGN}/npay-event-all/#domestic`
/** 네이버페이 혜택 페이지 (해외) */
export const NAVERPAY_BENEFIT_FOREIGN = `${domains.CAMPAIGN}/npay-event-all/#foreign`
/** 해외 현장결제 고객센터 */
export const INTERNATIONAL_ONSITE_PAYMENT_HELP = stringifyUrl({
    url: `${domains.PC_HELP}/faq/list.help`,
    query: {
        categoryId: '10622',
    },
})

/** 네이버 카페 닫기 */
export const NAVER_CAFE_CLOSE = 'appurl://CLOSE_NPAY'

// 결제내역 로그인 브릿지
export const timelineLoginBridge = () => {
    return stringifyUrl({
        url: `${domains.PAY}/historybenefit/intro`,
        query: {
            rurl: getHref(),
        },
    })
}

export const getMembershipPromotionJoin = ({
    isAgree,
    dtmSource,
    dtmMedium,
    dtmCampaign,
    scrollTo,
    evt,
    benefitFrom,
}: {
    isAgree: boolean
    dtmSource?: string
    dtmMedium?: string
    dtmCampaign?: string
    scrollTo?: string
    evt?: string
    benefitFrom?: string
}) => {
    return stringifyUrl({
        url: `${domains.NID}/membership/join`,
        query: {
            ...(isAgree ? {m: 'joinAgree'} : {}),

            ...(dtmSource ? {dtm_source: dtmSource} : {}),

            ...(dtmMedium ? {dtm_medium: dtmMedium} : {}),

            ...(dtmCampaign ? {dtm_campaign: dtmCampaign} : {}),
            ...(scrollTo ? {scrollTo} : {}),
            ...(evt ? {evt} : {}),
            ...(benefitFrom ? {benefitFrom} : {}),
        },
    })
}

// 간편계좌 등록
export const getRegisterEasyBank = (keepQuery = false) => {
    return stringifyUrl({
        url: `${domains.PAY}/mydata/registration/remit/agreement`,
        query: {
            finance: 'bank',
            target: 'remit',
            rurl: keepQuery ? getHref() : getCurrentPath(),
            curl: keepQuery ? getHref() : getCurrentPath(),
        },
    })
}

/** FDS Block 페이지 */
export const getFDSBlock = ({
    unavailablePaymentType,
    blockReturnUrl,
    isAnonymous = false,
    language = 'ko',
}: {
    unavailablePaymentType: Maybe<FDSBlockReasonType>
    blockReturnUrl?: string
    isAnonymous?: boolean
    language?: 'ko' | 'en' | 'ja' | 'zh'
}) => {
    const targetURL = isAnonymous
        ? `${domains.PAY}/member/${language}/block/BLK005`
        : `${domains.PAY}/member/block/${unavailablePaymentType ?? FDS_BLOCK_REASON.UNKNOWN}`

    /** AML 인증이 필요한 케이스 */
    const requiredAmlCertification =
        unavailablePaymentType === FDS_BLOCK_REASON.UNABLE_TO_PAYMENT_FOR_AML_EDD ||
        unavailablePaymentType === FDS_BLOCK_REASON.UNABLE_TO_PAYMENT_FOR_AML_CDD

    const amlAdviceUrl = stringifyUrl({
        url: targetURL,
        query: {rurl: blockReturnUrl || getCurrentPath()},
    })
    /**
     * rurl: AML인증수행 후 되돌아올 주소
     * surl: AML인증수행 중 뒤로가기 클릭시 이탈할 주소
     * @ref https://oss.fin.navercorp.com/Product-Planning/Online-Payment_Plan/issues/465#issuecomment-1758837
     */

    const amlEddBlockUrl = stringifyUrl({
        url: amlAdviceUrl,
        query: {
            surl: amlAdviceUrl,
        },
    })

    return requiredAmlCertification ? amlEddBlockUrl : targetURL
}

/** 신한카드 제휴 이벤트 광고 링크 */
export const shinhanPartnershipCardBenefit = () => {
    return stringifyUrl({
        url: 'https://internal.pay.naver.com/access/payment/card/r/go',
        query: {
            redirectUrl: 'https://mkt.naver.com/event/npay-shinhanassociated',
            redirectUrl1: getCurrentPath(),
            redirectUrl2: getCurrentPath(),
        },
    })
}

/** 네이버 현대카드 혜택 */
export const naverHyundaiCardBenefit = () => {
    return stringifyUrl({
        url: `${domains.PC_MARKETING}/naverhyundaicard2/`,
        query: {
            eventCode: 'NAV04',

            redirect_Url1: getCurrentPath(),
        },
    })
}

/** 네이버 현대카드 카드신청 페이지 */
export const naverHyundaiCard = () => {
    return stringifyUrl({
        url: `${domains.PC_MARKETING}/naverhyundaicard2/`,
        query: {
            eventCode: 'NAV09',

            redirect_Url1: getCurrentPath(),
        },
    })
}

/** 로그인 url **/
export const getLoginUrl = ({returnUrl, svcType}: {svcType: 262144 | 64; returnUrl?: string}) => {
    return stringifyUrl({
        url: `${domains.NID}/nidlogin.login`,
        query: {
            svctype: svcType,
            url: returnUrl ?? location.href,
        },
    })
}

/** 실명인증 페이지 url */
export const getRealNameCheckPage = (returnUrl?: string, exitUrl?: string) => {
    return stringifyUrl({
        url: `${domains.NID}/mobile/user/help/realNameCheck.nhn`,
        query: {
            rurl: returnUrl ?? encodeURIComponent(location.href),
            surl: exitUrl ?? (document.referrer || domains.NAVER),
        },
    })
}

/** 네이버예약 주문완료 redirect */
export const getEasyBookingResult = ({
    productApiType,
    orderNo,
    productOrderNo,
    itemOptionCode,
}: {
    /** API 버전 */
    productApiType: 'API_VERSION_10' | 'API_VERSION_20' | 'API_SHOPN'
    /** 주문완료 No */
    orderNo: string
    /** 상품 번호 */
    productOrderNo: string
    /** 상품 번호 */
    itemOptionCode: string
}) => {
    return productApiType === 'API_VERSION_20'
        ? // 네이버예약 주문완료 redirect (주문단위)
          stringifyUrl({
              url: `${domains.BOOKING_API}/v3.1/custom/naver-pay/v2/redirect/${orderNo}/detail`,
              query: {
                  npay: '1',
              },
          })
        : // 네이버예약 주문완료 redirect (상품주문단위)
          stringifyUrl({
              url: `${domains.BOOKING_API}/v3.1/custom/naver-pay/redirect/${productOrderNo}/detail`,
              query: {
                  npay: '1',
                  itemOptionCode,
              },
          })
}

/**
 *  viewMembershipTermOfUse: 멤버십 이용약관
 *  viewMembershipBilling 결제 및 멤버십 유의사항
 *  viewMembership3rd: 네이버-제휴사 간 개인정보 동의 약관
 *  viewMembership3rdToNaver: 제휴사-네이버 간 개인정보 동의 약관
 */
export const getMembershipQuickJoinTerm = ({
    termType,
}: {
    termType: 'viewMembershipTermOfUse' | 'viewMembershipBilling' | 'viewMembership3rd' | 'viewMembership3rdToNaver'
}) => {
    if (termType === 'viewMembershipTermOfUse' || termType === 'viewMembershipBilling') {
        return stringifyUrl({
            url: `${domains.NID}/user2/common/terms/terms2`,
            query: {
                t: termType === 'viewMembershipTermOfUse' ? 'MembershipTermOfUse' : 'MEM_billing',
            },
        })
    }

    return stringifyUrl({
        url: `${domains.NID}/user2/common/terms/terms.nhn`,
        query: {
            m: termType,
        },
    })
}

type GiftSendUrlParams = {
    /**
     * 화면 흐름 추적용 보조 키
     * - 스토어 상품상세로 부터 주입되며, 선물받을 사람 선택 후 주문서 재진입 시 유지되어야 합니다.
     * @ref https://oss.fin.navercorp.com/Product-Planning/Order_Plan/issues/2507
     */
    actionUID?: string
    /** 선물 가능한 아이템 개수 */
    availableCount: number
    /** 친구 세션 키 */
    friendsSessionKey?: Maybe<string>
    /** 주문서 ID */
    orderSheetId: string
}

/** 선물하기 URL */
export const getGiftSendUrl = ({actionUID, orderSheetId, availableCount, friendsSessionKey}: GiftSendUrlParams) => {
    return stringifyUrl({
        url: `${domains.GIFT}/mygift/send`,
        query: {
            serviceId: 'gift',
            snapshotId: orderSheetId,
            multiSelectLimit: availableCount,
            ...(friendsSessionKey && {
                sessionKey: friendsSessionKey,
            }),
            ...(actionUID && {'nl-au': actionUID}),
        },
    })
}

/** AML CDD 이행 (AML 이행 페이지 URL) */
export const getAMLRegister = ({amlToken, isPC = false}: {amlToken: string; isPC?: boolean}) => {
    return stringifyUrl({
        url: `${domains.PAY}/member/aml/cdd/register`,
        query: {
            treatmentService: 'ORDER',
            amlToken,
            ...(isPC
                ? {fromPC: 'Y'}
                : {
                      surl: getCurrentPath(),
                      rurl: getCurrentPath(),
                  }),
        },
    })
}

/** 배송조회 URL */
export const getDeliveryTrackingUrl = ({
    productOrderNo,
    deliveryNo,
    closeType = 'close',
    user = 'customer',
}: {
    productOrderNo: string
    deliveryNo: string
    closeType?: 'back' | 'close'
    user?: 'customer' | 'seller'
}) => {
    return stringifyUrl({
        url: `${domains.ORDERS}/order/delivery/tracking/${productOrderNo}/${deliveryNo}`,
        query: {
            closeType,
            user,
        },
    })
}

/** 구독상세 URL */
export const getSubscriptionDetailUrl = ({
    isPC,
    subscriptionId,
    scheduleId,
}: {
    isPC: boolean
    subscriptionId: string
    scheduleId: string
}) => {
    return `${isPC ? domains.SHOPPING : domains.M_SHOPPING}/my/subscriptions/${subscriptionId}/schedules/${scheduleId}`
}

/** 패밀리 맴버십 설정 */
export const getFamilyMembershipSetting = ({from}: {from?: 'join'} = {}) => {
    return stringifyUrl({
        url: `${domains.PAY}/member/settings/family-payment/manage`,
        query: {
            ...(from ? {from} : {}),
        },
    })
}

/** 구매확정 연장 정보 Url */
export const getPurchaseConfirmationExtensionUrl = ({
    isPC,
    orderNo,
    productOrderNo,
}: {
    isPC: boolean
    orderNo: string
    productOrderNo: string
}) => {
    return `${isPC ? domains.PC_ORDER : domains.PAY_M}/o/purchaseDecisionExtension/${orderNo}/${productOrderNo}/info`
}

/** 페이 홈 */
export const getPayHome = ({isMobile}: {isMobile: boolean}) => {
    return isMobile ? `${domains.PAY}/mydata/home` : `${domains.PAY}/pcpay`
}

// libs/web/core/constants/src/lib/product.ts 참고
type BranchMarketType = string

/** 주문상세 > 장보기 혜택함 URL */
export const getMarketBenefitUrl = ({isPC, marketType}: {isPC: boolean; marketType?: BranchMarketType}) =>
    stringifyUrl({
        url: `${isPC ? domains.SHOPPING : domains.M_SHOPPING}/market/my/benefit`,
        query: {subVertical: marketType},
    })

/**
 * 유입경로 적용된 URL 생성
 * @see https://wiki.fin.navercorp.com/spaces/FIN/pages/8813032/%EA%B0%80%EB%A7%B9%EC%A0%90%ED%9A%8C%EC%9B%90-%EC%9C%A0%EC%9E%85%EA%B2%BD%EB%A1%9C%EB%B0%8F+%EB%A1%9C%EA%B7%B8%EC%95%84%EC%9D%B4%EC%97%B0%EB%8F%99+inflow.pay.naver.com
 */
export const getInflowUrl = ({
    no,
    tr,
    pType,
    retUrl,
    aId,
    saveTrackChannel,
    saveTime,
}: {
    /** 가맹점 번호 */
    no?: string
    /** 유입경로 코드 */
    tr: string
    /** PC/MO 구분 */
    pType: 'P' | 'M'
    /** 이동할 url */
    retUrl: string
    /**
     * - 가맹점 accountId
     * - no가 없는 경우 사용됨
     * - no 또는 aId 둘중 하나는 있어야 함
     */
    aId?: string
    /**
     * - 저장된 유입경로 코드
     * - 찜이나 장바구니에서 저장된 유입경로를 전송하기 위한 필드
     */
    saveTrackChannel?: string
    /**
     * - 저장된 시간
     * - 찜이나 장바구니에서 저장된 시간을 전송하기 위한 필드
     */
    saveTime?: number
}) => {
    if (!retUrl || !tr || (!no && !aId)) {
        return retUrl
    }

    return stringifyUrl({
        url: `${domains.INFLOW}/rd`,
        query: {
            no,
            tr,
            pType,
            retUrl,
            aId,
            saveTrackChannel,
            saveTime,
        },
    })
}

/** 서치게이트 적용된 url @see https://wiki.fin.navercorp.com/pages/viewpage.action?pageId=153886061 */
export const getSearchGateUrl = ({
    nvMid,
    catId,
    frm,
    t,
    h,
}: {
    /** 상품 ID */
    nvMid: string
    /** 리프 카테고리 ID */
    catId: string
    /** 지표코드 */
    frm: string
    /** 현재시간 36진법 변환 후 upperCase 변환 값 */
    t: string
    /** 따로 전달된 hash key + t + nvMid 3개를 합쳐 SHA1 으로 암호화 한 값 */
    h: string
}) => {
    return stringifyUrl({
        url: `${domains.SHOPPING_CR}/v2/bridge/searchGate`,

        query: {
            nv_mid: nvMid,
            cat_id: catId,
            frm,
            t,
            h,
        },
    })
}

/** 포인트 적립내역 URL */
export const getPointHistoryUrl = () => {
    return `${domains.PAY}/pointshistory/list?category=all`
}

/** 선물 카드 */
export const getGiftCardUrl = ({orderNo}: {orderNo: string}) => {
    return stringifyUrl({
        url: `${domains.GIFT}/mygift/complete`,
        query: {
            orderId: orderNo,
            serviceId: 'gift',
            layer: 'close',
        },
    })
}

/** 직거래 유도 어뷰징 판매자 신고 url */
export const getMerchantDirectDealAbusingReportUrl = ({isMobileDisplay}: {isMobileDisplay: boolean}) => {
    return isMobileDisplay
        ? stringifyUrl({
              url: `${domains.M_HELP}/faq/list.help`,
              query: {
                  rootCategoryId: 10505,
                  faqId: 14188,
              },
          })
        : stringifyUrl({
              url: `${domains.PC_HELP}/faq/content.help`,
              query: {
                  faqId: 14188,
              },
          })
}

/** 카드 재등록 버튼 / 설정 > 카드관리  (회원 담당)) */
export const getCardReRegisterUrl = ({language}: {language: 'ko' | 'en' | 'ja' | 'zh'}) => {
    return `${domains.FOREIGN_SETTING}/management/${language}/payments`
}

/** 외국인 전용 예약 고객센터 */
export const getForeignBookingHelp = () => {
    /**
     * en으로 고정
     * @see https://oss.fin.navercorp.com/Product-Planning/DeFign_Plan/issues/1578#issuecomment-1883683
     * */
    return `${domains.HELP_PC}/alias/en.booking/24236.naver`
}

/** 편의점 택배 예약 */
export const getBookingConvenienceStoreDeliveryUrl = ({productOrderNo}: {productOrderNo: string}) => {
    return stringifyUrl({
        url: `${domains.BOOKING_DEV}/parcel-delivery/c2c-booking`,
        query: {
            productOrderNo,
        },
    })
}

/** 네이버 전자문서 조회 납부 */
export const NAVER_INVOICE_INQUIRY = `${domains.INVOICE}/main/inquiry`
